module.exports = __webpack_public_path__ + "img/algorithm-icon.d3299c76.png";